import { render, staticRenderFns } from "./questionsDetail4.vue?vue&type=template&id=067fb9b2&"
import script from "./questionsDetail4.vue?vue&type=script&lang=js&"
export * from "./questionsDetail4.vue?vue&type=script&lang=js&"
import style0 from "./questionsDetail4.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports